import { H3, Tooltip } from '@wheely/ui-kit';
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl';

import { Icon } from '@src-common/view/components/Icon';

import s from './styles.module.css';

type Props = {
  amount: number;
  currencyCode: string;
  periodStart: Date;
  periodEnd: Date;
  timezone?: string;
};

const UpcomingBill = ({ amount, currencyCode, periodStart, periodEnd, timezone }: Props) => (
  <div className={s.upcomingBill}>
    <div className={s.titleWrapper}>
      <H3 className={s.upcomingBillTitle}>
        <FormattedNumber value={amount} style="currency" currency={currencyCode} />
      </H3>
      <Tooltip
        content={
          <FormattedMessage
            defaultMessage="Next Payment"
            id="vl+HQ6"
            description="Next payment label"
          />
        }
      >
        <div className={s.infoIconWrapper}>
          <Icon icon="info" size="18px" />
        </div>
      </Tooltip>
    </div>
    <div className={s.upcomingBillSubtitle}>
      <FormattedMessage
        defaultMessage="Period: {start} – {end}"
        id="M+0Th6"
        description="Next payment period label"
        values={{
          start: <FormattedDate value={periodStart} timeZone={timezone} />,
          end: <FormattedDate value={periodEnd} timeZone={timezone} />,
        }}
      />
    </div>
  </div>
);

export { UpcomingBill };
